import { Checkbox } from '@ui/themed';
import { t } from 'i18next';
import { useEnv } from '../../../context/env-context';
import { type ColumnId, resolveColumnHeadingKey, TABLE_COLUMNS } from '../constants';

type ColumnPickerProps = {
  visibleColumns: Set<ColumnId>;
  onToggleColumn: (columnId: ColumnId) => void;
};

export function ColumnPickerContent({ visibleColumns, onToggleColumn }: ColumnPickerProps) {
  const { platform } = useEnv();
  const toggleableColumns = TABLE_COLUMNS.filter((col) => !col.alwaysVisible);

  return (
    <div className="flex flex-col gap-2">
      {toggleableColumns.map((col) => {
        const key = resolveColumnHeadingKey(col, platform);
        return (
          <Checkbox
            key={col.id}
            label={key ? t(key) : ''}
            checked={visibleColumns.has(col.id)}
            onChange={() => onToggleColumn(col.id)}
          />
        );
      })}
    </div>
  );
}
